module.exports = __webpack_public_path__ + "img/item_infected_tip.539984e0.png";